module.exports = __webpack_public_path__ + "static/media/logo_vietinbank.0413e60b.svg";